<template>
  <div class="home">
    <Header :present-page="presentPage" />
    <div class="top-box flex">
      <div>
        <p>线路数(条)</p>
        <span>{{total.totalLine}}</span>
      </div>
      <div>
        <p>总里程和(km)</p>
        <span>{{total.totalMileage}}</span>
      </div>
      <div>
        <p>桥梁总数(座)</p>
        <span>{{total.totalBride}}</span>
      </div>
      <div>
        <p>支座数量(个)</p>
        <span>{{total.totalBearing}}</span>
      </div>
      <div>
        <p>导风屏数量(个)</p>
        <span>{{total.totalWindGuide}}</span>
      </div>
      <div>
        <p>阻力器数量(个)</p>
        <span>{{total.totalDamping}}</span>
      </div>
      <div>
        <p>产品总数量(个)</p>
        <span>{{total.totalProduct}}</span>
      </div>
    </div>
    <Map />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header/header.vue";
import Map from "@/components/home/map.vue";
import { totalData } from "@/api/index/index.js";

export default {
  components: {
    Header,
    Map,
  },
  data() {
    return {
      presentPage: '',
      query: {},
      total: {}
    };
  },
  mounted() {
    // console.log(this.$route)
    this.presentPage = this.$route.query.name
    if (this.$route.matched[0].path == '/') {
      this.presentPage = '首页'
    }
    totalData(this.query).then(res => {
      if (res.code == 200) {
        this.total = res.data
      }
    }).catch(res => {
      console.log(res)
    });
  },
  methods: {

  },
};
</script>
<style scoped>
.top-box {
  justify-content: space-between;
  margin: 20px 30px;
  font-family: PingFangSC-Semibold;
}
.top-box div {
  width: 180px;
  height: 90px;
  padding: 20px 0 0 28px;
  text-align: left;
  color: #fff;
  line-height: 1;
  background: url(~@/assets/images/index-box.png) no-repeat center;
  background-size: 100%;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
}
.top-box span {
  font-size: 30px;
  line-height: 1.4;
  font-family: Alibaba-PuHuiTi-H;
}
</style>
